import { cn } from '@/lib/utils';

interface UserNameCellProps {
  name?: string | null;
  /** Shown under the name, since names are not unique; left out while it is unknown. */
  email?: string | null;
  className?: string;
}

/** A person in a table cell: their name with their email as the subtitle. */
export const UserNameCell = ({ name, email, className }: UserNameCellProps) => (
  <div className={cn('flex min-w-0 flex-col', className)}>
    <span className="truncate font-medium">{name || '-'}</span>
    {email && <span className="truncate text-xs text-muted-foreground">{email}</span>}
  </div>
);
